import { Box, Link } from '@chakra-ui/react'
import { FaBuilding, FaCrown, FaUsers } from 'react-icons/fa'
import { IoFlash } from 'react-icons/io5'
import { PricePlan } from '../../types/subscription'
import { Plan } from './components/PricePlansComponents'

export const PRICE_PLAN_LABEL: Record<PricePlan, string> = {
  [PricePlan.LITE]: 'Lite',
  [PricePlan.PRO]: 'Pro',
  [PricePlan.TEAM_STARTER]: 'Team Starter',
  [PricePlan.TEAM_PRO]: 'Team Pro',
  [PricePlan.ENTERPRISE]: 'Enterprise',
}

export const PRICE_PLAN_UNIT_PRICE: Partial<Record<PricePlan, number>> = {
  [PricePlan.LITE]: 35,
  [PricePlan.PRO]: 65,
  [PricePlan.TEAM_STARTER]: 79,
  [PricePlan.TEAM_PRO]: 89,
}

export const INDIVIDUAL_PLANS: Plan[] = [
  {
    id: PricePlan.LITE,
    name: 'Lite',
    icon: IoFlash,
    price: PRICE_PLAN_UNIT_PRICE[PricePlan.LITE],
    priceLabel: 'per user per month',
    description: 'Perfect for individual practitioners getting started',
    features: [
      { text: '30 scripts per month', included: true },
      { text: '1 free admin user', included: true },
      { text: 'Send script via SMS and email', included: true },
      { text: 'Self-managed billing for multiple users', included: true },
      { text: 'Real Time Prescription Monitoring(RTPM)', included: true },
    ],
    buttonText: 'Get Started',
    buttonVariant: 'secondary',
    note: 'No credit card needed for free trial',
    pricePlan: PricePlan.LITE,
  },
  {
    id: PricePlan.PRO,
    name: 'Pro',
    icon: FaCrown,
    price: PRICE_PLAN_UNIT_PRICE[PricePlan.PRO],
    priceLabel: 'per user per month',
    description: 'For busy practitioners who need more flexibility',
    features: [
      { text: 'Everything in Lite plan, plus:', included: true, showIcon: false },
      { text: 'Unlimited scripts per month', included: true },
      { text: 'Create multiple scripts', included: true },
      { text: 'Renew scripts (Coming soon)', included: false },
    ],
    buttonText: 'Get Started',
    buttonVariant: 'secondary',
    popular: true,
    note: 'No credit card needed for free trial',
    pricePlan: PricePlan.PRO,
  },
]

export const TEAM_PLANS: Plan[] = [
  {
    id: PricePlan.TEAM_STARTER,
    name: 'Team Starter',
    icon: FaUsers,
    price: PRICE_PLAN_UNIT_PRICE[PricePlan.TEAM_STARTER],
    priceLabel: 'per user per month',
    description: 'Unlimited prescriptions for growing teams',
    features: [
      { text: 'Everything in Pro plan, plus:', included: true, showIcon: false },
      { text: 'Share organization patients', included: true },
    ],
    buttonText: 'Get Started',
    buttonVariant: 'primary',
    note: 'No credit card needed for free trial',
    pricePlan: PricePlan.TEAM_STARTER,
    seatCustomizable: true,
  },
  {
    id: PricePlan.TEAM_PRO,
    name: 'Team Pro',
    icon: FaUsers,
    price: PRICE_PLAN_UNIT_PRICE[PricePlan.TEAM_PRO],
    priceLabel: 'per user per month',
    description: 'Unlimited prescriptions for growing teams',
    features: [
      { text: 'Everything in Team Starter plan, plus:', included: true, showIcon: false },
      { text: 'Manage multiple locations (Coming soon)', included: false },
    ],
    buttonText: 'Get Started',
    buttonVariant: 'primary',
    note: 'No credit card needed for free trial',
    pricePlan: PricePlan.TEAM_PRO,
    seatCustomizable: true,
  },
  {
    id: PricePlan.ENTERPRISE,
    name: 'Enterprise',
    icon: FaBuilding,
    priceLabel: 'Contact us',
    description: 'For organisations intending to purchase 50+ prescribing seats',
    features: [
      { text: 'Everything in Team plan, plus:', included: true, showIcon: false },
      { text: 'Single Sign On (SSO)', included: true },
      { text: 'Priority Customer Support', included: true },
      { text: 'API Integrations *', included: true },
    ],
    buttonText: 'Talk to Us',
    buttonVariant: 'primary',
    note: (
      <Box>
        * Please complete the{' '}
        <Link color="customBlue.100" target="_blank" href="https://forms.office.com/r/eeY9504g7x">
          RxPad Integration Questionnaire
        </Link>{' '}
        to help us better assess your integration needs.
      </Box>
    ),
    pricePlan: PricePlan.ENTERPRISE,
  },
]
